export const DISCORD = "discord";
export const TWITTER = "twitter";
export const TELEGRAM = "telegram";
export const FARCASTER = "farcaster";
export const BLUESKY = "bluesky";
